(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FunzioneDeleteController',FunzioneDeleteController);

    FunzioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Funzione'];

    function FunzioneDeleteController($uibModalInstance, entity, Funzione) {
        var vm = this;

        vm.funzione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Funzione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
